import { LitElement, css, html, render, styleMap, ref, createRef, live } from 'lit'
import { AppElement } from "./mixins.js"

import { getRowStyle, getScrollbarStyle, cardCSS, orderCSS, statusHistoryCSS } from "./common-css.js"
import { singleShotTransition } from "./common.js"



let closeButton = html`
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="9.35189" cy="8.97591" r="8.56673" fill="url(#paint0_radial_708_31)"/>
            <path d="M14.0661 5.97744L12.3518 4.26318L9.35337 7.26166L6.35488 4.26318L4.64062 5.97744L7.63911 8.97592L4.64062 11.9744L6.35488 13.6887L9.35337 10.6902L12.3518 13.6887L14.0661 11.9744L11.0676 8.97592L14.0661 5.97744Z" fill="white"/>
            <path d="M13.4806 1.95985C17.305 4.21464 13.7921 8.6528 9.35246 8.6528V8.6528C4.91283 8.6528 1.39992 4.21464 5.22434 1.95985C6.43465 1.24628 7.84573 0.836914 9.35246 0.836914C10.8592 0.836914 12.2703 1.24628 13.4806 1.95985Z" fill="url(#paint1_linear_708_31)"/>
        <defs>
        <radialGradient id="paint0_radial_708_31" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(9.35198 10.2012) rotate(32.6765) scale(7.79389)">
            <stop offset="0.661458" stop-color="#FF0000"/>
            <stop offset="1" stop-color="#B42930"/>
        </radialGradient>
        <linearGradient id="paint1_linear_708_31" x1="9.83831" y1="0.0882772" x2="9.83831" y2="7.94409" gradientUnits="userSpaceOnUse">
            <stop stop-color="white"/>
            <stop offset="1" stop-color="white" stop-opacity="0"/>
        </linearGradient>
        </defs>
    </svg>
`

let expandButton = html`
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <ellipse cx="9.82976" cy="9.6499" rx="9.53874" ry="9.44092" fill="url(#paint0_radial_1030_40)"/>
        <path d="M18.8685 9.6499C18.8685 14.583 14.8266 18.5908 9.82976 18.5908C4.83293 18.5908 0.791016 14.583 0.791016 9.6499C0.791016 4.71682 4.83293 0.708984 9.82976 0.708984C14.8266 0.708984 18.8685 4.71682 18.8685 9.6499Z" stroke="#707070" stroke-opacity="0.4"/>
        <ellipse cx="9.83105" cy="5.73535" rx="6.48925" ry="4.45117" fill="url(#paint1_linear_1030_40)"/>
        <path d="M4.86828 15.3394L11.3987 12.8496L6.44367 8.53024L4.86828 15.3394Z" fill="#373737"/>
        <path d="M14.788 3.95845L8.25757 6.44822L13.2126 10.7676L14.788 3.95845Z" fill="#373737"/>
        <defs>
            <radialGradient id="paint0_radial_1030_40" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(9.82976 15.6049) rotate(-90) scale(13.2473 13.3846)">
                <stop offset="0.200283" stop-color="#EEEEEE"/>
                <stop offset="1" stop-color="#939393"/>
            </radialGradient>
            <linearGradient id="paint1_linear_1030_40" x1="9.83105" y1="1.28418" x2="9.83105" y2="9.62561" gradientUnits="userSpaceOnUse">
                <stop stop-color="white"/>
                <stop offset="1" stop-color="white" stop-opacity="0"/>
            </linearGradient>
        </defs>
    </svg>
`

let collapseButton = html`
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <ellipse cx="10.2497" cy="9.6499" rx="9.53874" ry="9.44092" fill="url(#paint0_radial_1030_41)"/>
        <path d="M19.2884 9.6499C19.2884 14.583 15.2465 18.5908 10.2497 18.5908C5.25285 18.5908 1.21094 14.583 1.21094 9.6499C1.21094 4.71682 5.25285 0.708984 10.2497 0.708984C15.2465 0.708984 19.2884 4.71682 19.2884 9.6499Z" stroke="#707070" stroke-opacity="0.4"/>
        <ellipse cx="10.251" cy="5.73535" rx="6.48925" ry="4.45117" fill="url(#paint1_linear_1030_41)"/>
        <path d="M10.7823 9.43608L17.3127 6.94631L12.3577 2.62692L10.7823 9.43608Z" fill="#373737"/>
        <path d="M9.87976 10.0991L3.34937 12.5888L8.30437 16.9082L9.87976 10.0991Z" fill="#373737"/>
        <defs>
            <radialGradient id="paint0_radial_1030_41" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(10.2497 15.6049) rotate(-90) scale(13.2473 13.3846)">
                <stop offset="0.200283" stop-color="#EEEEEE"/>
                <stop offset="1" stop-color="#939393"/>
            </radialGradient>
            <linearGradient id="paint1_linear_1030_41" x1="10.251" y1="1.28418" x2="10.251" y2="9.62561" gradientUnits="userSpaceOnUse">
                <stop stop-color="white"/>
                <stop offset="1" stop-color="white" stop-opacity="0"/>
            </linearGradient>
        </defs>
    </svg>
`

function clip(num, min, max) {
    return Math.min(max, Math.max(min, num))
}


export class FloatingBox extends LitElement {
    $title      = createRef()
    $content    = createRef()
    $window     = createRef()

    static get properties() {
        return {
          name: { type: String },
        }
    }

    constructor() {
        super()
        this.name = "..."
        this.frame = this.backupFrame = new DOMRect(100, 100, 500, 500)        
        this.pickpt = {x: 0, y: 0}
    }

    connectedCallback() {
        super.connectedCallback()
        this.addEventListener("pointermove", evt => {
            if (this.windowMode && this.hasPointerCapture(evt.pointerId)) {
                let br = this.$window.value.getBoundingClientRect()
                switch (this.windowMode) {
                    case `move`:   
                        let px = {x: evt.clientX - br.x, y: evt.clientY - br.y}         

                        if (this.hasPointerCapture(evt.pointerId)) {
                            let wb = this.$window.value.getBoundingClientRect()
                        
                            let ox = this.frame.x + (evt.clientX - this.pickpt.x)
                            let oy = this.frame.y + (evt.clientY - this.pickpt.y)

                            this.$window.value.style.left = `${clip(ox, 0, window.innerWidth - wb.width)}px`
                            this.$window.value.style.top = `${clip(oy, 0, window.innerHeight - wb.height)}px`
                        }
                        break
                    case `ns-resize`:
                        const new_height = evt.clientY - br.y
                        if (new_height > this.minHeight) {
                            this.$window.value.style.height = `${new_height}px`
                        }
                        break
                    case `ew-resize`:
                        const new_width = evt.clientX - br.x
                        if (new_width > this.minWidth) {
                            this.$window.value.style.width = `${new_width}px`
                        }
                }
            }
        })

        this.addEventListener("pointerup", evt => {
            if (this.hasPointerCapture(evt.pointerId)) {
                this.releasePointerCapture(evt.pointerId)
                this.frame = new DOMRect(parseFloat(this.$window.value.style.left), parseFloat(this.$window.value.style.top), this.frame.width, this.frame.height)
                this.$window.value.style.userSelect = `text`
            }
        })

        this.addEventListener("keydown", evt => {
            switch (evt.key) {
                case 'Escape' :
                    this.hide(evt)
                    break
                case 'Enter' :
                    let btn = this.$content.value.querySelector(`[data-key=Enter]`)
                    if (btn) {
                        btn.click()
                    }
                    break
            }
        })

        this.addEventListener("close", evt => {
            this.hide()
            evt.stopPropagation()
        })
    }

    render() {
        let win_style = `
            width: ${this.frame.width ? Math.round(this.frame.width) + "px" : "auto" }; 
            height: ${this.frame.height ? Math.round(this.frame.height) + "px" : "auto" };
            left: ${Math.round(this.frame.x)}px;
            top: ${Math.round(this.frame.y)}px;
        `

        return html`
            <div part="window" style="${live(win_style)}" ${ref(this.$window)} @pointermove="${this.winPtrMoveCallback}" @pointerdown="${this.winPtrDownCallback}">
                <div part="header" @pointerdown="${this.startMoving}">
                    <span ${ref(this.$title)}>${this.name}</span>
                    <div class="buttons">
                        <button @pointerdown="${this.maximized ? this.minimize : this.maximize}" @pointerup="${evt => evt.stopPropagation()}">
                            ${this.maximized ? collapseButton : expandButton}
                        </button>
                        <button @pointerdown="${this.hide}" @pointerup="${evt => evt.stopPropagation()}">
                            ${closeButton}
                        </button>
                    </div>
                </div>
                <div part="content" ${ref(this.$content)}>
                </div>   
            </div>
        `
    }

    winPtrDownCallback(evt) {
        this.setAttribute("tabindex", 0)
        this.focus()
        if (this.windowMode) {
            this.capture(evt)
        }
    }

    winPtrMoveCallback(evt) {
        var rect = this.$window.value.getBoundingClientRect();       
        var x = (evt.clientX - rect.left) / rect.width;
        var y = (evt.clientY - rect.top) / rect.height;

        this.windowMode = null
        this.$window.value.style.cursor = `default`

        const pp = {x: 1.0 / rect.width, y: 1.0 / rect.height}
        if (Math.abs(1 - x) <= pp.x * 3) {
            this.$window.value.style.cursor = this.windowMode = `ew-resize`
            
        } else {
            if (Math.abs(1 - y) <= pp.y * 3) {
                this.$window.value.style.cursor = this.windowMode = `ns-resize`
            }
        }
    }

    capture(evt) {
        this.$window.value.style.userSelect = `none`
        this.pickpt = {x: evt.clientX, y: evt.clientY}
        this.setPointerCapture(evt.pointerId)
    }

    startMoving(evt) {
        this.windowMode = `move`
        this.capture(evt)
    }

    show(title, content, frame) {
        let spinner = this.$content.value.querySelector("good-spinner")
        if (spinner) {
            spinner.remove()
        }

        this.frame = frame 

        this.minWidth = this.minWidth || frame.width
        this.minHeight = this.minHeight || frame.height
        this.maximized = false

        this.style.opacity = `1`
        this.style.pointerEvents = `all`
        this.$title.value.innerText = title
        
        render(content, this.$content.value, {host: this.$content.value})

        this.requestUpdate()
    }

    hide(evt) {
        this.style.pointerEvents = `none`
        this.style.opacity = `0`
        if (evt) {
            evt.stopPropagation()
        }
    }

    maximize() {
        this.storeFrame()
        this.frame = new DOMRect(0, 0, window.innerWidth, window.innerHeight)
        this.maximized = true
        singleShotTransition(this.shadowRoot, `[part=window]`, `0.3s`)
        this.requestUpdate()
    }

    minimize() {
        this.restoreFrame()
        singleShotTransition(this.shadowRoot, `[part=window]`, `0.3s`)
        this.requestUpdate()
        this.maximized = false
    }

    storeFrame() {
        this.backupFrame = this.$window.value.getBoundingClientRect()
    }

    restoreFrame() {
        this.frame = this.backupFrame
    }

    static get styles() {
        return [
        getRowStyle(),
        getScrollbarStyle(),
        cardCSS,
        orderCSS,
        statusHistoryCSS,
        css`
            :host {
                top: 0px;
                left: 0px;
                display: flex;
                opacity: 0;
                pointer-events: none;
                position: fixed;
                width: 100vw;
                height: 100vh;
                background: #0000;
                z-index: 10;
            }

            :host(:focus) {
                outline: none;
            }
        
            [part=window] {
                position: absolute;
                left: 0px;
                top: 0px;
                border: solid #0001 1px;
                background: white;
                border-radius: 8px;
                box-shadow: 0px 4px 19px rgb(0 0 0 / 26%);
                display: grid;
                grid-template-rows: 30px minmax(10px, 1fr);
                overflow: hidden;
            }

            [part=header] {
                width: 100%;
                display: flex;
                justify-content: space-between;
                padding: 5px 10px;
                box-sizing: border-box;
                cursor: move;
                background: linear-gradient(180deg, #FFFFFF 50%, #F3F3F3 88.54%, #E0E0E0 99.48%);
                border-radius: 8px 8px 0px 0px;
            }

            [part=header] .buttons {
                display: flex;
                align-items: center;
                gap: 7px;
            }

            [part=header] button {
                appearance: none;
                background: none;
                border: none;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                padding: 0px;
            }

            [part=content] {
                display: flex;
                justify-content: center;
                align-items: center;
                margin: 10px;
                overflow: none;
                max-height: 100%;
                overflow-y: auto;
                position: relative;
            }

            good-spinner {
                position: absolute;
                width: 100%;
                height: 100%;
                background: #fffa;
            }
        `]
    }
}

window.customElements.define('floating-box', FloatingBox)




export class DialogBox extends AppElement {

    $pane = createRef()

    constructor() {
        super()

        this.resizeObserver = new ResizeObserver(entries => {
            entries.forEach(entry => {
                this.w  = entry.contentRect.width
                this.h = entry.contentRect.height
            })
        })
    }

    connectedCallback() {
        super.connectedCallback()

        let centerX = window.innerWidth / 2,
            centerY = window.innerHeight / 2

               
        this.w = this.w || 400
        this.h = this.h || 200 

        if (window.innerWidth < window.innerHeight) {
            this.x = 0
            this.y = 0
        } else {   
            this.x = centerX - this.w / 2
            this.y = centerY - this.h / 2
        }

        this.addEventListener("close", () => {
            this.remove()
        })
    }


    startMove(evt) {
        this.$pane.value.setPointerCapture(evt.pointerId)
        this.capturePoint = { x: evt.clientX, y: evt.clientY }
    }

    
    makeMove(evt) {
        if (this.$pane.value.hasPointerCapture(evt.pointerId)) {
            let {x, y} = this.capturePoint,
                newX   = this.x + evt.clientX - x,
                newY   = this.y + evt.clientY - y
            
            if ((newX > this.x && newX + this.w < window.innerWidth) || (newX < this.x && newX > 0)) {
                this.x = newX
            }

            if ((newY > this.y && newY + this.h < window.innerHeight) || (newY < this.y && newY > 0)) {
                this.y = newY
            }

            this.capturePoint = { x: evt.clientX, y: evt.clientY }
            this.requestUpdate()
        }
    }

    endMove(evt) {
        this.$pane.value.releasePointerCapture(evt.pointerId)
    }

    update() {
        super.update()
        this.$pane.value && this.resizeObserver.unobserve(this.$pane.value)
    }
    
    render() {
        let paneStyle = {
            left: `${this.x}px`,
            top: `${this.y}px`
        }

        return html`
            <div class="background" @click=${() => this.remove()} part="background"></div>
            <div class="pane" ${ref(this.$pane)} @pointerdown=${this.startMove} @pointerup=${this.endMove} @pointermove=${this.makeMove} style=${styleMap(paneStyle)}>
                <slot></slot>
            </div>
        `
    }

    updated() {
        this.resizeObserver.observe(this.$pane.value)
    }

    static get styles() {
        return css`
            :host {
                position: fixed;
                top: 0px;
                left: 0px;
                width: 100vw;
                height: 100vh;
                z-index: 500;
            }

            .background {
                position: fixed;
                height: 100vh;
                width: 100vw;
                top: 0;
                left: 0;
                background: #0000;
                z-index: 10;
            }

            @media (orientation: portrait) {
                .background {
                    background: #0002;
                }
            }

            .pane {
                position: fixed;
                z-index: 11;
            }
        `
    }
}

window.customElements.define('dialog-box', DialogBox)


export class ContextMenu extends AppElement {    
    $box = createRef()

    static get properties() {
        return {
            dropdown: {type: Boolean}
        }
    }

    constructor() {
        super()
        this.dropdown = false
    }
    
    render() {
        return html`
            <div class="box" part="box" ${ref(this.$box)} @contextmenu=${evt => evt.stopPropagation()}>
                <slot></slot>
            </div>
            <div class="backdrop" @mousedown=${() => this.remove()}></div>        
        `
    }

    updated() {
        if (!this.dropdown) {
            let left = Math.min(Math.max(this.left, 0), window.innerWidth - this.$box.value.offsetWidth),
            top  = Math.min(Math.max(this.top, 0), window.innerHeight - this.$box.value.offsetHeight)

            this.$box.value.style = `left: ${left}px; top: ${top}px`
        }
    }


    static get styles() {
        return css`
            :host {
                display: inline-block;
                position: absolute;
                width: 0px;
                height: 0px;
                margin: 0px;
            }


            .box {
                position: fixed;
                background: white;
                z-index: 101;
                display: flex;
                flex-direction: column;
                border: 1px solid #0002;
                box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.1);
                border-radius: 4px;
                animation: 0.2s popup forwards;
                transform-origin: top left;
            }

            .backdrop {
                background: #0000;
                position: fixed;
                top: 0px;
                left: 0px;
                width: 100vw;
                height: 100vh;
                z-index: 100;
            }

            @keyframes popup {
                from {
                    opacity: 0;
                    scale: 0.5;
                }
                to {
                    opacity: 1;
                    scale: 1;
                }
            }
        `
    }
}

window.customElements.define('context-menu', ContextMenu)